import React from 'react';
import Card from '../../components/card';
import { DollarTextField } from '../../components/MaskedTextField';
import style from '../../styles/form';
import { BorrowerCard, CoborrowerCard } from '../card-lenses';

const validateCash = (num) =>
  num != undefined && num !== '' ? '' : 'Please enter a dollar amount';

const Bonus = ({ model, onChange, id, ...cardProps }) => (
  <Card
    title={`About how much bonus income did ${id === 'borrower' ? 'you' : 'they'} receive in:`}
    {...cardProps}
  >
    <p>Please estimate within a few thousand dollars</p>
    <DollarTextField
      value={model.get('lastYearBonus')}
      onChange={onChange.bind(null, 'lastYearBonus')}
      style={style.threeQuarters}
      floatingLabelText={'Past 12 months bonus'}
      hintText="$/Year"
      validate={validateCash}
    />

    <DollarTextField
      value={model.get('twoYearOldBonus')}
      onChange={onChange.bind(null, 'twoYearOldBonus')}
      style={style.threeQuarters}
      floatingLabelText={'Previous year bonus (12-24 months ago)'}
      hintText="$/Year"
      validate={validateCash}
    />
  </Card>
);

Bonus.completed = ({ model }) =>
  !(validateCash(model.get('lastYearBonus')) || validateCash(model.get('twoYearOldBonus')));

export const PrimaryBorrowerBonus = BorrowerCard(Bonus, 'PrimaryBorrowerBonus', {
  id: 'borrower'
});

export const CoborrowerBonus = CoborrowerCard(Bonus, 'CoborrowerBonus', {
  id: 'coborrower'
});



// WEBPACK FOOTER //
// ./src/cards/bonus-cards/bonus.js